import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ButtonsConfiguration,
  InfoButtonConfiguration,
  UserListButtonConfiguration,
} from 'src/app/models/buttons-config';
import { Rating } from 'src/app/models/rating';
import { Record } from 'src/app/models/record';
import { RssItem } from 'src/app/models/rss';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-rss-all-items',
  templateUrl: './rss-all-items.component.html',
  styleUrls: ['./rss-all-items.component.scss'],
})
export class RssAllItemsComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  readonly MAX_ITEMS_PER_REQUEST = 6;

  containerRecord: Record;
  containerRecordRating: Rating;
  loadingRecord: boolean;
  loadingMoreItems: boolean;
  canGoBack: boolean;
  rssItems: RssItem[] = [];
  readOnly: boolean;
  hasMoreItems: boolean;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private localeService: LocaleService,
    private authService: AuthService,
    private configService: ConfigService,
    router: Router
  ) {
    this.route.params.subscribe((params) => {
      const slug = params.slug;
      const recordId = slug.split('-').pop();

      this.loadingRecord = true;
      this.apiService.getRecord(recordId).subscribe((record) => {
        if (!record.container) {
          return router.navigate(['/']);
        }

        this.containerRecord = record;
        this.loadMore();
        this.loadingRecord = false;

        this.getRating();
      });
    });

    this.canGoBack = history.length > 0;
    this.readOnly = !this.authService.isAuthenticated();
  }

  ngOnInit() {}

  goBack() {
    history.back();
  }

  getRecordSlug(record: Record): string {
    return Util.slugifyRecord(record);
  }

  getRating() {
    this.apiService.getRecordRating(this.containerRecord.id).subscribe((rating) => {
      this.containerRecordRating = rating;
    });
  }

  loadMore() {
    this.loadingMoreItems = true;

    const offset = this.rssItems.length;
    this.apiService
      .getRssItems(this.containerRecord.id, this.MAX_ITEMS_PER_REQUEST, offset)
      .subscribe((rssItemsPage) => {
        this.rssItems.push(...rssItemsPage.items);
        this.updateHasMoreItems();
        this.loadingMoreItems = false;
      });
  }

  private updateHasMoreItems() {
    this.hasMoreItems = this.rssItems.length < this.containerRecord.containerData.totalItems;
  }

  copyLink() {
    const slug = Util.slugify(this.containerRecord.title) + '-' + this.containerRecord.id;
    const url = new URL(Util.getOrigin() + '/rss/' + slug);
    Util.copyToClipboard(url.href);
    this.toastService.showToast('messages.copied', 'info');
  }
}
